<template>
  <div class="text-inline">
    <template v-if="isTooltip">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            :color="busenaColor"
            small
            outlined
            class="mr-2"
            v-if="isBusena"
            v-bind="attrs"
            v-on="on"
          >
            {{ busenaText }}
          </v-chip>
        </template>
        <div class="tooltip-text">
          {{ tooltip }}
        </div>
      </v-tooltip>
    </template>
    <template v-if="!isTooltip">
      <v-chip :color="busenaColor" small outlined class="mr-2" v-if="isBusena">
        {{ busenaText }}
      </v-chip>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ElBusena',
  props: {
    busena: [String, Boolean],
    color: { type: String, default: 'default' },
    taipNe: { type: Boolean, default: false },
    tooltip: { type: String, default: null },
  },
  computed: {
    isBusena() {
      return this.busena || this.taipNe
    },
    busenaColor() {
      if (this.taipNe) {
        return this.busena ? 'green' : 'default'
      } else {
        return this.color
      }
    },
    busenaText() {
      if (this.taipNe) {
        return this.busena ? 'Taip' : 'Ne'
      } else {
        return this.busena
      }
    },
    isTooltip() {
      return !!this.tooltip
    },
  },
}
</script>

<style lang="scss" scoped></style>
